export function getDereferencedMultiLookupSids(fields: FieldDto[]): string[] {
    return fields.reduce((acc, curr) => {
        if (curr.type === 'multi_lookup') {
            acc.push(curr._sid)
        }

        return acc
    }, [] as string[])
}
